module.exports = __webpack_public_path__ + "img/logo.604c4df7.png";